/**
 * Data Structure representing rules that a webcode must follow
 */
class WebcodeRule {
  /**
   * Construct new WebcodeRule instance
   *
   * @param {string} pattern String containing regex pattern
   * @param {string} rule Text explaining rule requirement
   */
  constructor(pattern, rule) {
    this.pattern = new RegExp(`^${pattern}$`);
    this.rule = rule;
  }
}

/**
 * Construct Vuex 'users' module
 *
 * @param {*} services Services object for API access
 * @return {*}
 */
export default function(services) {
  return {
    namespaced: true,
    state: {
      users: [],
      requiresUpdate: true,
      pagination: {
        rowsPerPage: Number.parseInt(localStorage.getItem('users/rowsPerPage')) || 5
      },
      search: '',
      webcodeRules: [],
      webcodeRulesRequireUpdate: true
    },
    mutations: {
      users(store, users) {
        store.users = users;
      },
      requiresUpdate(store, requiresUpdate) {
        store.requiresUpdate = requiresUpdate;
      },
      pagination(store, pagination) {
        store.pagination = pagination;
        localStorage.setItem('users/rowsPerPage', pagination.rowsPerPage);
      },
      search(store, search) {
        store.search = search;
      },
      webcodeRules(store, rules) {
        store.webcodeRules = rules.map((r) => new WebcodeRule(r.pattern, r.rule));
      },
      webcodeRulesRequireUpdate(store, requiresUpdate) {
        store.webcodeRulesRequireUpdate = requiresUpdate;
      }
    },
    actions: {
      initialize(context, forceUpdate) {
        if (context.state.requiresUpdate || forceUpdate) {
          context.commit('requiresUpdate', false);
          if (context.rootState.auth.user.scopes.auth.permissions.indexOf('VIEW_ALL_DATA') > -1 ||
            context.rootState.auth.user.scopes.auth.permissions.indexOf('EDIT_ALL_USERS') > -1 ||
            context.rootState.auth.groups.length > 0) {
            return services.authenticator.get('/users')
              .then((response) => {
                context.commit('users', response.data.data);
              });
          } else {
            context.commit('users', []);
          }
        }
      },
      setPagination(context, pagination) {
        context.commit('pagination', pagination);
      },
      setSearch(context, search) {
        context.commit('search', search);
      },
      reset(context) {
        context.commit('requiresUpdate', true);
        context.commit('search', '');
      },
      initializeWebcodeRules(context, forceUpdate) {
        if (context.state.webcodeRulesRequireUpdate || forceUpdate) {
          context.commit('webcodeRulesRequireUpdate', false);
          return services.authenticator.get('/user/webcodeRules')
            .then((response) => context.commit('webcodeRules', response.data.data));
        }
      }
    }
  };
}
